import * as React from "react";
import { forwardRef, memo } from "react";
const SvgConfirm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#0D41E1" }), /* @__PURE__ */ React.createElement("path", { d: "M17.5501 25.9996L11.8501 20.2996L13.2751 18.8746L17.5501 23.1496L26.7251 13.9746L28.1501 15.3996L17.5501 25.9996Z", fill: "white" }));
const ForwardRef = forwardRef(SvgConfirm);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
